// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Home__home___37uUv{font-size:16px;height:100vh;overflow-y:hidden;overflow-x:hidden;font-family:'Roboto', sans-serif}.Home__home___37uUv *{-webkit-font-smoothing:antialiased}.Home__card___2R0Rw{background-color:#fff;width:100%;min-height:300px;height:100%}\n", ""]);
// Exports
exports.locals = {
	"home": "Home__home___37uUv",
	"card": "Home__card___2R0Rw"
};
module.exports = exports;
